import PropTypes from 'prop-types'

const placeShape = {
  count: PropTypes.number,
  fullName: PropTypes.string,
  id: PropTypes.string,
  latitude: PropTypes.number,
  longitude: PropTypes.number,
  name: PropTypes.string,
  type: PropTypes.string,
  zoomLevel: PropTypes.number,
}

export default PropTypes.shape({ ...placeShape, parents: PropTypes.arrayOf(PropTypes.shape(placeShape)) })
